import '../css/index.scss'
import $ from 'jquery'
import { setupLenis } from "../scripts/lenis.js";

/**js**/
'use strict';

var windowWidth = $(window).width();
var windowHeight = $(window).height();
var BREAKPOINT_SP = 768;
var adjust = null;

const setup = () => {
  // 設定を行ったLenisのインスタンスを作成
  const lenis = setupLenis();

  // アンカーリンクを取得
  const anchors = document.querySelectorAll('.nav-item-link');
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      lenis.scrollTo( '#' + this.getAttribute('data-target'))
    });
  })
};

setup();

window.addEventListener('load',function(){

  let vw = window.innerWidth;
  let vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (windowWidth <= BREAKPOINT_SP) {
    adjust = windowHeight * .24;
  } else {
    adjust = windowHeight * .16;
  }

  const body = document.querySelector( 'body' );
  setTimeout(() => {
    body.classList.add('opening');
    setTimeout(() => {
      body.classList.add('complete');
      body.classList.remove('opening');
    }, 3200);
  }, 300);

});


// resize
var resizeTimer;
var interval = 600;

window.addEventListener('resize', function() {

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {
    windowHeight = $(window).height();

    let vw = window.innerWidth;
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  }, interval);

});

const listWrapperEl = document.querySelector('.side-scroll-list-wrapper');
const listEl = document.querySelector('.side-scroll-list');
let mm = gsap.matchMedia();

mm.add("(min-width: 769px)", () => {
  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const bgPosition = scrollTop / 64;

    if(bgPosition){
      if( bgPosition > 4.8 ) {
        document.getElementById('hero-title__logo').style.transform = `translateY(105%)`;
        document.getElementById('hero-title__logo-letter').style.transform = `translateY(105%)`;
        document.getElementById('hero-title__catch').style.opacity = `0`;
        document.getElementById('scrollsign').style.opacity = `0`;
      } else {
        document.getElementById('hero-title__logo').style.transform = `translateY(0)`;
        document.getElementById('hero-title__logo-letter').style.transform = `translateY(0)`;
        document.getElementById('hero-title__catch').style.opacity = `1`;
        document.getElementById('scrollsign').style.opacity = `1`;
      }

      if( bgPosition > 16 ) {
        document.getElementById('mainvisual').style.backgroundPosition = `center top -16.0vh`;
      } else {
        document.getElementById('mainvisual').style.backgroundPosition = `center top -${bgPosition}vh`;
      }
    }
  });
});

mm.add("(max-width: 768px)", () => {
  gsap.to(listEl, {
    x: () => -(listEl.clientWidth - listWrapperEl.clientWidth),
    ease: Power0.easeNone,
    scrollTrigger: {
      trigger: '.side-scroll',
      start: 'top top',
      end: () => `+=${listEl.clientWidth - listWrapperEl.clientWidth}`,
      scrub: true,
      pin: true,
      //pinSpacing: false,
      anticipatePin: 1,
      invalidateOnRefresh: true
    }
  });

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const bgPosition = scrollTop / 24;

    if(bgPosition){
      if( bgPosition > 30 ) {
        document.getElementById('mainvisual').style.backgroundPosition = `top left -30.0vw`;
      } else {
        document.getElementById('mainvisual').style.backgroundPosition = `top left -${bgPosition}vw`;
      }
    }
  });
});

$(function(){

  // animate
  var current_scrollY;
  current_scrollY = $( window ).scrollTop();
  triggerAnimation(current_scrollY);

  var naviTrigger_scrollY;
  naviTrigger_scrollY = $('#introduction').offset().top - 1;

  $(window).on('scroll', function () {

    current_scrollY = $( window ).scrollTop();
    triggerAnimation(current_scrollY);

    if (windowWidth <= BREAKPOINT_SP) {
      if( naviTrigger_scrollY <= current_scrollY ) {
        $('.js-drawer-nav').addClass('is-inview');
        $('.js-education-btn').addClass('is-inview');
      } else {
        $('.js-drawer-nav').removeClass('is-inview');
        $('.js-education-btn').removeClass('is-inview');
      }
    } else {
      if( naviTrigger_scrollY <= current_scrollY ) {
        $('.hero-title').css('opacity', '0');
        $('.js-social-link').addClass('is-inview');
      } else {
        $('.js-social-link').removeClass('is-inview');
        $('.hero-title').css('opacity', '1');
      }
    }

  });

  function triggerAnimation(scroll) {
    const scrollBottom = scroll + $(window).height();
    $('.animate').each(function() {
      const top = $(this).offset().top + adjust;
      if(scrollBottom > top) {
        $(this).addClass('is_animated');
      } else {
        // $(this).removeClass('is_animated');
      }
    })
  }


  /*----------------------------------------------------------
    drawer-nav
  ----------------------------------------------------------*/

  var gNavi = $('.drawer-nav');
  var gNaviButton = $('.js-drawer-nav');

  gNaviButton.on('click', function(){
    $('body').toggleClass('is-open');
  });

  $('.drawer-nav button').on('click', function(){
    $('body').toggleClass('is-open');
  });

});


/*----------------------------------------------------------
  #inquiry (accordion)
----------------------------------------------------------*/

const slideDown = function(el) {
  el.style.height = 'auto';
  let h = el.offsetHeight;
  el.animate({
    height: [ 0, h + 'px' ]
  }, {
    duration: 300,
  });
  el.style.height = 'auto';
  el.setAttribute('aria-hidden', 'false');
};

const slideUp = function(el) {
  let h = el.offsetHeight;
  el.style.height = h + 'px';
  el.animate({
    height: [ h + 'px', 0]
  }, {
    duration: 300,
  });
  el.style.height = 0;
  el.setAttribute('aria-hidden', 'true');
};

let activeIndex = null;

const accordions = document.querySelectorAll('.include-accordion');
accordions.forEach(function (accordion) {

  const accordionBtns = accordion.querySelectorAll('.js-accordionBtn');
  accordionBtns.forEach( function(accordionBtn, index) {
    accordionBtn.addEventListener('click', function(e) {
      activeIndex = index;
      const isActive = e.target.parentNode.classList.toggle('active');
      accordionBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      const content = accordionBtn.nextElementSibling;
      if (isActive) {
        slideDown(content);
      }else{
        slideUp(content);
      }
      accordionBtns.forEach( function(accordionBtn, index) {
        if (activeIndex !== index) {
          accordionBtn.parentNode.classList.remove('active');
          accordionBtn.setAttribute('aria-expanded', 'false');
          const openedContent = accordionBtn.nextElementSibling;
          slideUp(openedContent);
        }
      });
    });
  });
});
